<form [formGroup]="aboutForm" (ngSubmit)="submitForm()" class="auth-wrapper">

  <div class="auth-card">
    <h2 class="title">Tell us more about you</h2>
    <p class="subtitle">
      Help us understand your event organizing needs better.
    </p>
    <div class="error-text text-center mb-4" *ngIf="error">
      {{error}}
    </div>


    <div class="row">
      <!-- First / Last Name -->
      <div class="col-lg-6 ">
        <div class="field">
          <label>First Name <span class="required">*</span></label>
          <input type="text" formControlName="firstName" placeholder="John">
          <div class="error"
            *ngIf="(aboutForm.get('firstName')?.touched || submitted) && aboutForm.get('firstName')?.invalid">

            <small *ngIf="aboutForm.get('firstName')?.errors?.['required']">
              First name is required *
            </small>

            <small *ngIf="aboutForm.get('firstName')?.errors?.['minlength']">
              Minimum 2 characters required *
            </small>

          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="field">
          <label>Last Name <span class="required">*</span></label>
          <input type="text" formControlName="lastName" placeholder="Doe">
          <div class="error"
            *ngIf="(aboutForm.get('lastName')?.touched || submitted) && aboutForm.get('lastName')?.invalid">

            <small *ngIf="aboutForm.get('lastName')?.errors?.['required']">
              Last name is required *
            </small>

            <small *ngIf="aboutForm.get('lastName')?.errors?.['minlength']">
              Minimum 2 characters required *
            </small>

          </div>
        </div>
      </div>


      <div class="col-lg-12">

        <div class="field">
          <label>Display / Brand Name <span class="required">*</span></label>
          <input type="text" formControlName="brand" placeholder="Your Brand Name">
          <div class="error" *ngIf="(aboutForm.get('brand')?.touched || submitted) && aboutForm.get('brand')?.invalid">

            <small *ngIf="aboutForm.get('brand')?.errors?.['required']">
              Brand name is required *
            </small>

          </div>
        </div>
      </div>

      <!-- business type -->

      <!-- <div class="col-lg-6">
        <div class="field">
          <label>Business Type <span class="required">*</span></label>
          <ng-select [items]="businessTypes" bindLabel="name" bindValue="name" [searchable]="true"
            placeholder="Select Business Type" formControlName="businessType">
          </ng-select>
          <div class="error"
            *ngIf="(aboutForm.get('businessType')?.touched || submitted) && aboutForm.get('businessType')?.invalid">

            <small *ngIf="aboutForm.get('businessType')?.errors?.['required']">
              Business Type is required*
            </small>

          </div>
        </div>
      </div> -->


      <!-- Email / Mobile -->
      <div class="col-lg-6">
        <div class="field">
          <label>Email Address <span class="required">*</span></label>
          <input type="email" formControlName="email" placeholder="user@example.com" readonly>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="field">
          <label>Mobile Number <span class="required">*</span></label>
          <div class="mobile-group about_form">


            <ng-select [items]="countriesCode" bindLabel="phonecode" bindValue="phonecode" style="width: 220px;"
              [searchable]="true" placeholder="" formControlName="countryCode" (keypress)="numberOnly($event)">
              <ng-template ng-option-tmp let-item="item">

                <span style="font-size: 16px; margin-right: 6px;">
                  {{ item.emoji }}
                </span>
                <span>+{{ item.phonecode }}</span>
              </ng-template>


              <ng-template ng-label-tmp let-item="item">
                <span style="font-size: 16px; margin-right: 6px;">
                  {{ item.emoji }}
                </span>
                <span class="code_co">+{{ item.phonecode }}</span>
              </ng-template>
            </ng-select>


            <div class="code_input">
              <input type="tel" formControlName="mobile" placeholder="98765 43210">
            </div>

          </div>
          <div class="error"
            *ngIf="(aboutForm.get('mobile')?.touched || submitted) && aboutForm.get('mobile')?.invalid">

            <small *ngIf="aboutForm.get('mobile')?.errors?.['required']">
              Mobile is required*
            </small>

            <small *ngIf="aboutForm.get('mobile')?.errors?.['minlength']">
              Mobile must be at least 6 digits
            </small>

            <small *ngIf="aboutForm.get('mobile')?.errors?.['maxlength']">
              Mobile must be maximum 15 digits
            </small>

            <small *ngIf="aboutForm.get('mobile')?.errors?.['pattern']">
              Only numbers are allowed
            </small>

          </div>
          <div class="error"
            *ngIf="(aboutForm.get('countryCode')?.touched || submitted) && aboutForm.get('countryCode')?.invalid">
            <small *ngIf="aboutForm.get('countryCode')?.errors?.['required']">
              Country code is required*
            </small>
          </div>


        </div>
      </div>

      <!-- Country / State / City -->
      <div class="col-lg-6">
        <div class="field">
          <label>Country <span class="required">*</span></label>
          <ng-select [items]="countries" bindLabel="name" (change)="onCountryChange($event)" bindValue="name"
            [searchable]="true" placeholder="Select Country" formControlName="country" class="custom-ng"
            [appendTo]="'body'">
          </ng-select>

          <div class="error"
            *ngIf="(aboutForm.get('country')?.touched || submitted) && aboutForm.get('country')?.invalid">

            <small *ngIf="aboutForm.get('country')?.errors?.['required']">
              Country is required *
            </small>

          </div>

        </div>
      </div>



      <div class="col-lg-6">
        <div class="field">
          <label>State <span class="required">*</span></label>
          <ng-select [items]="states" bindLabel="name" (change)="onStateChange($event)" bindValue="name"
            [searchable]="true" placeholder="Select State" formControlName="state">
          </ng-select>
          <div class="error" *ngIf="(aboutForm.get('state')?.touched || submitted) && aboutForm.get('state')?.invalid">

            <small *ngIf="aboutForm.get('state')?.errors?.['required']">
              State is required *
            </small>

          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="field ">
          <label>City <span class="required">*</span></label>
          <ng-select [items]="cities" bindLabel="name" bindValue="name" [searchable]="true" placeholder="Select City"
            formControlName="city">
          </ng-select>

          <div class="error" *ngIf="(aboutForm.get('city')?.touched || submitted) && aboutForm.get('city')?.invalid">


            <small *ngIf="aboutForm.get('city')?.errors?.['required']">
              City is required *
            </small>

          </div>

        </div>
      </div>

      <div class="col-lg-12">
        <div class="field">
          <label>Website / Social Media <small class="one_req"> (At least one required) </small> <span
              class="required">*</span></label>
          <input type="text" formControlName="website" placeholder="https://www.example.com">
          <div class="error"
            *ngIf="(aboutForm.get('website')?.touched || submitted) && aboutForm.get('website')?.invalid">

            <small *ngIf="aboutForm.get('website')?.errors?.['required']">
              Website / Social Media is required *
            </small>
            <small *ngIf="aboutForm.get('website')?.errors?.['pattern']">
              Enter a valid URL (https://example.com)
            </small>

          </div>
        </div>
      </div>

    </div>


    <div class="actions">
      <!-- <button type="button" class="btn secondary" routerLink="/login">Back</button> -->

      <button type="submit" class="primary-btn" *ngIf="!formfillNext"> Continue </button>
      <button type="button" class="primary-btn" (click)="next()" *ngIf="formfillNext"> Next </button>
    </div>


  </div>


  <div class="step-dots">
    <span class="dot"></span>
    <span class="dot active"></span>
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </div>
</form>

<div class="logout">
  <button (click)="logout()" class="primary-btn">Logout</button>
</div>